import React, { ReactElement } from 'react'
import uiConfigStore from 'store/uiConfig/uiConfig'
import { useSnapshot } from 'valtio'
import styles from './UiConfigRelationsPanel.module.less'
import UiConfigRelationsTree from './UiConfigRelationsTree'

export const RELATIONS_PANEL_COLLAPSED_KEY = 'uiConfig.relationsPanel.collapsed'

type Props = {
  collapsed?: boolean
  onCollapse?: () => void
  onExpand?: () => void
}

export default function UiConfigRelationsPanel({ collapsed = false, onCollapse, onExpand }: Props): ReactElement {
  const snap = useSnapshot(uiConfigStore)
  const editingUid = snap.editingUid ?? null
  const open = !collapsed

  return (
    <div className={`${styles.UiConfigRelationsPanel} ${open ? styles.UiConfigRelationsPanel__open : ''}`}>
      {open ? (
        <>
          <div className={styles.UiConfigRelationsPanel_Header}>
            {onCollapse ? (
              <button
                type="button"
                className={styles.UiConfigRelationsPanel_Header_CollapseButton}
                onClick={onCollapse}
                title="Collapse relations panel"
                aria-label="Collapse relations panel"
                aria-expanded={open}
              >
                ▸
              </button>
            ) : null}
            <span className={styles.UiConfigRelationsPanel_Header_Title}>Relations</span>
          </div>

          <div className={styles.UiConfigRelationsPanel_Body}>
            {editingUid != null ? (
              <UiConfigRelationsTree editingUid={editingUid} />
            ) : (
              <div className={styles.UiConfigRelationsPanel_Empty}>
                Select a config in the left panel to see its relations.
              </div>
            )}
          </div>
        </>
      ) : onExpand ? (
        <button
          type="button"
          className={styles.UiConfigRelationsPanel_Tab}
          onClick={onExpand}
          title="Open relations panel"
          aria-label="Open relations panel"
          aria-expanded={open}
        >
          <span className={styles.UiConfigRelationsPanel_TabIcon}>◂</span>
          <span className={styles.UiConfigRelationsPanel_TabLabel}>Relations</span>
        </button>
      ) : null}
    </div>
  )
}
